import { BaseApi as Base } from '@micromag/data';
import { postJSON, getCSRFHeaders } from '@folklore/fetch';

class ContactApi extends Base {
    send(data = null) {
        return postJSON(this.route('contact.form'), data, {
            headers: getCSRFHeaders(),
            credentials: 'include',
        });
    }
}

export default ContactApi;
